































































































































import { Component, Mixins } from 'vue-property-decorator'
import DexieService from '@/services/dexie-service'
import { Milk } from '@/interfaces/Milk'
import axios from 'axios'
import moment from 'moment'
import SnackbarService from '@/services/snackbar-service'

@Component({
  components: {},
})
export default class MilkView extends Mixins(DexieService, SnackbarService) {
  milks: Milk[] = []

  defaultMilk: Milk = {
    day: '',
    liter: '',
    cows: '',
    price: '',
    farm_id: 0,
  }

  milk: Milk = {
    day: '',
    liter: '',
    cows: '',
    price: '',
    farm_id: 0,
  }

  lastMilk: any

  search = ''

  deleteModalIsOpen = false

  addModalIsOpen = false

  headers = [
    { text: 'Dia', value: 'day' },
    { text: 'Litros', value: 'liter' },
    { text: 'Vacas', value: 'cows' },
    { text: 'Precio', value: 'price' },
    { text: 'Total', value: 'priceLiter' },
    { text: 'Finca', value: 'farm' },
    { text: '', value: 'actions' },
  ]

  created() {
    this.$store.state.showAppbar = true
    this.$store.state.changeBack = '/home'
    this.$store.state.navbarText = 'leche'
    this.defaultMilk.day = moment().format('YYYY-MM-DD')
    this.getMilks(false)
  }

  getMilks(update: boolean) {
    this.$store.state.loading = true
    if (navigator.onLine) {
      axios
        .get(`/milks`)
        .then((res: any) => {
          this.milks = res.data[0].milks
          this.milks.forEach((milk: Milk) => {
            milk.day = moment.utc(milk.day).format('YYYY-MM-DD')
            milk.priceLiter = milk.price * milk.liter
          })
          this.$db.milks.bulkPut(this.milks)
          if (res.data[0].last_milk) {
            this.defaultMilk.price = res.data[0].last_milk.price
            this.defaultMilk.cows = res.data[0].last_milk.cows
          } else {
            this.defaultMilk.price = '850'
            this.defaultMilk.cows = '80'
          }
          this.milk = JSON.parse(JSON.stringify(this.defaultMilk))
        })
        .catch(error => {
          this.notify({ text: `Server error. ${error}` })
        })
        .finally(() => {
          this.$store.state.loading = false
        })
    } else {
      this.$db.milks.toArray().then((milks: Milk[]) => {
        this.milks = milks
        this.milks.sort((m1: Milk, m2: Milk) => {
          return m1.day > m2.day ? -1 : 1
        })
        this.defaultMilk.price = this.milks[0].price
        this.defaultMilk.cows = this.milks[0].cows
        this.milks.forEach((milk: Milk) => {
          milk.day = moment.utc(milk.day).format('YYYY-MM-DD')
          milk.priceLiter = milk.price * milk.liter
        })
        /* if (!update) {
          this.notify({ text: 'Using offline data', type: 'warning' })
        } */
        this.$store.state.loading = false
      })
    }
  }

  addUpdateMilk() {
    const payload = {
      id: this.milk.id ? this.milk.id : null,
      liter: this.milk.liter,
      day: this.milk.day,
      cows: this.milk.cows,
      price: this.milk.price,
      farm_id: this.milk.farm_id,
    }
    const url = `/milks`
    if (navigator.onLine) {
      axios
        .patch(url, payload)
        .then(() => {
          this.notify({ text: 'Leche aggregado exitosamente', type: 'success' })
          this.getMilks(true)
        })
        .catch(error => {
          if (error.response.status === 400) {
            this.notify({
              text: `${error.response.data.detail}`,
              type: 'error',
            })
          } else {
            this.notify({ text: `Server error. ${error}` })
          }
        })
        .finally(() => {
          this.addModalIsOpen = false
        })
    } else {
      if (this.milk.id) {
        this.$db.syncs.add({
          method: 'patch',
          timestamp: new Date().toISOString(),
          url,
          farm_id: this.milk.farm_id,
          action: 'Leche: Actualizar',
          message: `Actualizar leche para dia ${this.milk.day} (${this.milk.liter} litros, ${this.milk.cows} vacas)`,
          payload,
        })
        this.$db.milks.update(this.milk.id, payload).then(() => {
          this.getMilks(true)
          const text = 'Leche aggregado exitosamente (offline)'
          this.notify({ text, type: 'success' })
          this.addModalIsOpen = false
        })
      } else {
        this.$db.milks
          .where({ day: this.milk.day })
          .toArray()
          .then((milks: Milk[]) => {
            if (milks.length > 0) {
              const text = `Dia ${this.milk.day} ya existe`
              this.notify({ text })
            } else {
              this.$db.milks.add(this.milk)
              this.$db.syncs.add({
                method: 'patch',
                timestamp: new Date().toISOString(),
                url,
                farm_id: this.milk.farm_id,
                action: 'Leche: Aggregar',
                message: `Aggregar leche para dia ${this.milk.day} (${this.milk.liter} litros, ${this.milk.cows} vacas)`,
                payload,
              })

              const text = 'Leche aggregado exitosamente (offline)'
              this.notify({ text, type: 'success' })
              this.getMilks(true)
              this.addModalIsOpen = false
            }
          })
      }
    }
  }

  openDeleteModal(milk: Milk) {
    this.milk = milk
    this.deleteModalIsOpen = true
  }

  deleteMilk() {
    this.$store.state.loading = true
    const url = `/milks/${this.milk.id}`
    if (navigator.onLine) {
      axios
        .delete(url)
        .then(() => {
          this.notify({ text: 'Dia eliminado exitosamente', type: 'success' })
        })
        .catch(error => {
          this.notify({ text: `Server error. ${error}` })
        })
        .finally(() => {
          this.$store.state.loading = false
          this.deleteModalIsOpen = false
          this.addModalIsOpen = false
          this.getMilks(true)
        })
    } else {
      this.$db.milks.delete(this.milk.id)
      this.$db.syncs.add({
        method: 'delete',
        timestamp: new Date().toISOString(),
        url,
        farm_id: this.milk.farm_id,
        action: 'Leche: Eliminar',
        message: `Eliminar leche para dia ${this.milk.day}`,
      })
      this.notify({
        text: 'Dia eliminado exitosamente (offline)',
        type: 'success',
      })
      this.deleteModalIsOpen = false
      this.addModalIsOpen = false
      this.$store.state.loading = false
    }
  }

  openEditMilk(milk: Milk) {
    this.milk = JSON.parse(JSON.stringify(milk))
    this.addModalIsOpen = true
  }

  openAddMilk() {
    this.milk = JSON.parse(JSON.stringify(this.defaultMilk))
    this.addModalIsOpen = true
  }

  addPoints(x: string) {
    x = x.toString()
    const pattern = /(-?\d+)(\d{3})/
    while (pattern.test(x)) x = x.replace(pattern, '$1,$2')
    return x
  }
}
